import { render } from "./DefButtonPrimary.vue?vue&type=template&id=5c69dac3&scoped=true"
import script from "./DefButtonPrimary.vue?vue&type=script&lang=js"
export * from "./DefButtonPrimary.vue?vue&type=script&lang=js"

import "./DefButtonPrimary.vue?vue&type=style&index=0&id=5c69dac3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c69dac3"]])

export default __exports__